import React, { useState} from 'react';
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { UserContext } from '../context/UserContext';
// import { routes } from '../config/utility';
// import { useNavigate } from 'react-router-dom';

export const PromoCodeInput = ({ state, dispatch, applyPromoCode, promoError, promoSuccess }) => {
  const [loading, setLoading] = useState(false);
  // const { user } = useContext(UserContext);
  // const navigate = useNavigate();

  // const handleUpgradeClick = () => {
  //   const isConfirmed = window.confirm(
  //     "⚠️ Warning: Your current request form data will be lost. Are you sure you want to upgrade your membership now?"
  //   );

  //   if (isConfirmed) {
  //     toast.info('Redirecting to upgrade membership...', {
  //       position: 'top-right',
  //       autoClose: 3000,
  //     });
  //     navigate(routes.dashboard);
  //   }
  // };

  const handlePromoCodeSubmit = async () => {
    setLoading(true);
    try {
      applyPromoCode(state.promo_code.trim());
    } catch (error) {
      // Error handling
    } finally {
      setLoading(false);
    }
  };

  // if (!user?.paid) {
  //   return (
  //     <div className="mb-4 sm:mb-6 p-4 bg-purple-50 rounded-lg border border-purple-100">
  //       <div className="flex items-start space-x-3">
  //         <div className="flex-shrink-0">
  //           <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
  //             <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
  //           </svg>
  //         </div>
  //         <div className="flex-1">
  //           <h3 className="text-sm sm:text-base font-semibold text-purple-800">
  //             Premium Feature 💎
  //           </h3>
  //           <p className="mt-1 text-sm text-purple-700">
  //             Promo code feature is available for premium members only. Upgrade your membership to unlock exclusive discounts!
  //           </p>
  //           <button 
  //           type='button'
  //             className="mt-3 inline-flex items-center px-4 py-2 border border-purple-600 
  //               text-sm font-medium rounded-md text-purple-600 bg-white 
  //               hover:bg-purple-50 hover:text-purple-700
  //               active:bg-purple-100
  //               transition-all duration-200
  //               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
  //             onClick={handleUpgradeClick}
  //           >
  //             <span className="mr-2">Upgrade Now</span>
  //             <span className="animate-pulse">✨</span>
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mb-4 sm:mb-6">
      <div className="space-y-2 sm:space-y-3 mb-4">
        <h2 className="text-base sm:text-lg font-semibold text-gray-700">
          Got a Promo Code? 🎁
        </h2>
        <p className="text-sm sm:text-base text-gray-600">
          Enter your promo code below to enjoy exclusive discounts!
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 sm:gap-0">
        <input
          type="text"
          name="promo_code"
          value={state.promo_code}
          onChange={(e) =>
            dispatch({ type: "UPDATE_FIELD", field: "promo_code", payload: e.target.value })
          }
          className={`block w-full p-3 sm:p-2.5 text-sm sm:text-base border 
            ${promoError ? 'border-red-500' : 'border-gray-300'} 
            rounded-lg sm:rounded-r-none
            focus:ring-2 focus:ring-purple-500 focus:border-purple-500
            disabled:bg-gray-50 disabled:cursor-not-allowed
            transition-all duration-200`}
          placeholder="Enter your promo code"
          disabled={loading}
        />
        <button
          type="button"
          onClick={handlePromoCodeSubmit}
          className={`w-full sm:w-auto px-4 py-3 sm:py-2.5 
            bg-purple-600 hover:bg-purple-700 active:bg-purple-800
            text-white font-medium text-sm sm:text-base
            rounded-lg sm:rounded-l-none
            transition-all duration-200
            focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2
            ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center gap-2">
              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
              </svg>
              <span>Validating...</span>
            </div>
          ) : (
            'Apply Code'
          )}
        </button>
      </div>

      {/* Status Messages */}
      {promoError && (
        <p className="mt-2 text-sm text-red-600 flex items-center">
          <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
          </svg>
          {promoError}
        </p>
      )}
      {promoSuccess && (
        <p className="mt-2 text-sm text-green-600 flex items-center">
          <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
          </svg>
          {promoSuccess}
        </p>
      )}
    </div>
  );
};
